import { GitBranch } from 'lucide-react';
import { TOOL_JOB_REGISTRY } from '@shared/types/continuations';
import type { FlowComposerDraft } from '@shared/types/flow-composer';

type ToolContinuitySummaryProps = Pick<
  FlowComposerDraft,
  'continuationCapability' | 'continuityContract'
>;

export const ToolContinuitySummary = ({
  continuationCapability,
  continuityContract,
}: ToolContinuitySummaryProps) => {
  const facts = continuityContract?.producedFacts ?? [];
  const job = continuationCapability
    ? TOOL_JOB_REGISTRY[continuationCapability.jobKey]
    : null;

  return (
    <section
      aria-labelledby="tool-continuity-title"
      className="rounded-2xl border border-domino-cardBorder bg-domino-white p-5 shadow-[var(--domino-shadow-soft)]"
    >
      <div className="flex items-center gap-2">
        <span className="text-domino-aubergine">
          <GitBranch className="h-4 w-4" aria-hidden="true" />
        </span>
        <h2 id="tool-continuity-title" className="font-semibold text-domino-ink">
          Après utilisation
        </h2>
      </div>

      <div className="mt-4 grid border-t border-domino-cardBorder lg:grid-cols-2 lg:divide-x lg:divide-domino-cardBorder">
        <div className="pt-4 lg:pr-5">
          <p className="text-sm font-medium text-domino-inkSoft">Domino conserve</p>
          {facts.length > 0 ? (
            <p className="mt-2 text-sm leading-6 text-domino-ink">
              {facts.map((fact) => fact.label).join(' · ')}
            </p>
          ) : (
            <p className="mt-2 text-sm leading-6 text-domino-inkSoft">
              Le résultat restera visible dans l’historique.
            </p>
          )}
        </div>

        <div className="mt-4 border-t border-domino-cardBorder pt-4 lg:mt-0 lg:border-t-0 lg:pl-5">
          <p className="text-sm font-medium text-domino-inkSoft">
            Proposition automatique
          </p>
          {continuationCapability && job ? (
            <>
              <p className="mt-3 text-sm leading-6 text-domino-ink">
                Domino peut proposer cet outil pour{' '}
                <span className="font-semibold">{job.label.toLocaleLowerCase('fr')}</span>
                , lorsque les informations requises sont disponibles.
              </p>

            </>
          ) : (
            <p className="mt-3 text-sm leading-6 text-domino-inkSoft">
              Cet outil reste manuel et ne sera pas proposé automatiquement.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
